import createPermission from 'permissions/createPermission'

export const markAsViewed = createPermission('reports.review')
export const download = createPermission('reports.download')